import { ReferenceDataOptionLists } from './../../../constants/reference-data-option-lists';
import { Deserializable } from './../../deserializable';

export class ApplicationCaseSummaryDto implements Deserializable {
  public CaseNumber: string;
  public CaseNumberOriginal?: number;
  public CaseStatusCode: string;
  public LoanAmount?: number;
  public LoanGroupTypeCode: string;
  public CaseType: string;
  public SamIDCache: string;
  public MortgageAccountNumberHash: string;
  public IsCaseFromAClosedAccount: boolean;

  public IsMortgageAccount: boolean;
  public IsResidential: boolean;
  public IsBtl: boolean;

  private referenceDataOptionsList = ReferenceDataOptionLists;

  public deserialize(input: any): this {
    Object.assign(this, input);

    this.IsMortgageAccount = this.CaseType === this.referenceDataOptionsList.CaseTypeCustomerMortgageAccountOption;
    this.IsResidential = this.LoanGroupTypeCode === this.referenceDataOptionsList.LoanGroupTypeResidential;
    this.IsBtl = this.LoanGroupTypeCode === this.referenceDataOptionsList.LoanGroupTypeBuyToLet;

    return this;
  }
}
